export const Types = {
  FETCH_REQUEST: 'selectCompanies/FETCH_REQUEST',
  FETCH_SUCCESS: 'selectCompanies/FETCH_SUCCESS',
  FETCH_FAILURE: 'selectCompanies/FETCH_FAILURE',
}

const INITIAL_STATE = {
  data: [],
  loading: false,
  error: null,
}

export default function selectCompanies(state = INITIAL_STATE, action) {
  switch (action.type) {
    case Types.FETCH_REQUEST:
      return { ...state, loading: true, error: null }
    case Types.FETCH_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload.data,
      }
    case Types.FETCH_FAILURE:
      return { ...state, loading: false, error: action.payload }
    default:
      return state
  }
}

export const Creators = {
  fetchSelectCompaniesRequest: (data = {}) => ({
    type: Types.FETCH_REQUEST,
    payload: { data },
  }),
}
